import { render, staticRenderFns } from "./nationalityForm.vue?vue&type=template&id=8818a1c6"
import script from "./nationalityForm.vue?vue&type=script&lang=js"
export * from "./nationalityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports